export type DocumentType = 'contratos' | 'projetos' | 'notas-fiscais' | 'planilhas';

export type DocumentStatus = 'Produção' | 'Pré-Produção' | 'Pós-Produção' | 'Desenvolvimento' | 'Comercialização';

/** Time range filter options for document filtering */
export type TimeRange = '90-dias' | '30-dias' | 'este-mes' | 'todos';

/** Time range display labels for UI dropdowns */
export const TIME_RANGE_LABELS: Record<TimeRange, string> = {
  '90-dias': 'Nos próximos 90 dias',
  '30-dias': 'Nos próximos 30 dias',
  'este-mes': 'Este mês',
  'todos': 'Todos'
} as const;

/** Document type display labels for UI */
export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  'contratos': 'Contratos',
  'projetos': 'Projetos',
  'notas-fiscais': 'Notas Fiscais',
  'planilhas': 'Planilhas'
} as const;

export interface IResponsavel {
  id: number;
  name: string;
  avatar?: string;
}

export interface IDocumento {
  id: number;
  fileName: string;
  responsible: IResponsavel;
  date: string;
  fileType: string;
  stage: DocumentStatus;
  documentType: DocumentType;
  fileUrl: string;
  fileSize?: number;
}

export interface IDocumentStats {
  type: DocumentType;
  label: string;
  fileCount: number;
  totalSize: string;
  icon: string;
  percentage: number;
}

/** Enhanced document filters interface with all filtering options */
export interface IDocumentFilters {
  searchTerm: string;
  timeRange: TimeRange;
  documentType: DocumentType[];
  stage: DocumentStatus[];
}

/** Multi-page document preview interface for enhanced modal */
export interface IDocumentPage {
  /** Page number (1-indexed) */
  pageNumber: number;
  /** Thumbnail URL for preview strip */
  thumbnailUrl: string;
  /** Full-size URL for main preview */
  fullSizeUrl: string;
}

/** Enhanced document interface with multi-page support for modal */
export interface IDocumentoEnhanced extends IDocumento {
  /** Optional pages for multi-page documents (PDFs, etc) */
  pages?: IDocumentPage[];
  /** Optional description/supporting text */
  description?: string;
}
